const data = [
  { color: "red", count: 1, name: "ważne i pilne" },
  { color: "orange", count: 2, name: "ważne i niepilne" },
  { color: "blue", count: 3, name: "nieważne i pilne" },
  { color: "black", count: 4, name: "nieważne i niepilne" },
];

const TaskColorPicker = ({ active_color, setColor }) => {
  return (
    <div className="task-color-picker">
      {data.map(({ color, count, name }) => (
        <button
          key={name}
          type="button"
          className={`task-color-picker__button task-color-picker__button--${color} ${
            active_color === color ? "task-color-picker__button--active" : ""
          }`}
          onClick={() => setColor(color)}
        >
          <span className="task-color-picker__name">{name}</span>
          <span className="task-color-picker__count">{count}</span>
        </button>
      ))}
    </div>
  );
};

export default TaskColorPicker;
